import { NgModule } from '@angular/core';
import { DateTimePipe } from './date-time';

@NgModule({
  declarations: [
    DateTimePipe
  ],
  imports: [ ],
  exports: [
    DateTimePipe
  ]
})
export class DateTimeModule {}



// WEBPACK FOOTER //
// ./src/pipes/date-time/date-time.module.ts